// extracted by mini-css-extract-plugin
export default {"layout":"_0b8ab6717e _7d53336c3b _107d43053f","h_slide":"_73ff2a13ef","category":"_03b4b770c5 _4e892b5627 _242eddcf07"};